// extracted by mini-css-extract-plugin
export default {"bubbleCaseTable":"BubbleModuleCaseTable__bubbleCaseTable___k8d_t","header":"BubbleModuleCaseTable__header___PIL04","addBtn":"BubbleModuleCaseTable__addBtn___RuWFz"};